import PropTypes from 'prop-types'

import useDaiPermissions from 'hooks/useDaiPermissions'

const Permitted = ({ tag, fallback, children }) => {
  const { permitted, isLoadingStart } = useDaiPermissions()

  if (isLoadingStart) return null

  if (!permitted(tag)) return fallback || null

  return children
}

Permitted.propTypes = {
  tag: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  fallback: PropTypes.any,
  children: PropTypes.any,
}

export default Permitted
